import 'sanitize.css/sanitize.css';
import './src/styles/fonts.css';
import './src/styles/global.css';
